import { IconProps } from '@models/icons';

function UploadImageIcon(props: IconProps) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...props} >
            <path
                d="M12.6431 19.1428H3.14307C2.59078 19.1428 2.14307 18.6951 2.14307 18.1428V4.14282C2.14307 3.59054 2.59078 3.14282 3.14307 3.14282H19.1431C19.6954 3.14282 20.1431 3.59054 20.1431 4.14282V11.6428"
                stroke="black" strokeLinecap="round"/>
            <path d="M3.14307 18.6428L13.2895 8.49638C13.4848 8.30111 13.8014 8.30111 13.9966 8.49638L16.6431 11.1428"
                stroke="black" strokeLinecap="round"/>
            <circle cx="7.14307" cy="8.14282" r="1.5" stroke="black"/>
            <path d="M17.998 13.1428V20.8571" stroke="#262320" strokeLinecap="round"/>
            <path d="M14.1426 17.0002L21.8569 17.0002" stroke="#262320" strokeLinecap="round"/>
        </svg>
    );
}

export default UploadImageIcon;
